import styled from 'styled-components';

import { useCurrencyLocalizer, ICurrencyLocalizerOptions } from 'shared/hooks/useCurrencyLocalizer';
import { LOCALES } from 'localization/constants/configEnums';

interface ILocalizedCurrency extends ICurrencyLocalizerOptions {
  className?: string;
  'data-qa'?: string;
  price: number;
  locale?: LOCALES;
}

export const LocalizedCurrency = ({
  className,
  'data-qa': dataQa,
  price,
  locale,
  ...options
}: ILocalizedCurrency) => {
  const { localize } = useCurrencyLocalizer(locale);

  const localizedCurrency = localize(price, options);

  return (
    <LocalizedCurrency.Amount className={className} data-qa={dataQa}>
      {localizedCurrency}
    </LocalizedCurrency.Amount>
  );
};

LocalizedCurrency.Amount = styled.span`
  white-space: nowrap;
`;
